import classNames from 'classnames';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useFormatting } from '../../services/hooks/useFormatting';
import style from './TermsAndConditions.module.scss';

interface TermsAndConditions {
  link?: string;
  onlyMentionPartnerInFooter: boolean;
  partner: string;
}

const TermsAndConditionsComponent: FC<TermsAndConditions> = ({ link, partner, onlyMentionPartnerInFooter }) => {
  const { t } = useTranslation();
  const termsText = !link
    ? undefined
    : onlyMentionPartnerInFooter
      ? t('footer:whiteLabelTerms', { partner, link })
      : t('footer:terms', { partner, link });
  const { formattedText: terms } = useFormatting(termsText);

  const termsClasses = classNames('col-xs-12 col-md-7', style.termsText);

  return (
    <div className={style.terms}>
      {!!link && !!partner && <p className={termsClasses} dangerouslySetInnerHTML={{ __html: terms }} />}
      <div className={style.cookieStatementWrapper}>
        <p>
          <a href="https://www.guidion.com/privacy-cookie-statement" rel="noopener noreferrer" target="_blank">
            {t('footer:cookieStatement')}
          </a>
        </p>
        {/*
        Can be put back once the questionnare bug is fixed
        <LanguageSelector placement="footer-mobile" />
        */}
      </div>
    </div>
  );
};

export const TermsAndConditions = React.memo(TermsAndConditionsComponent);
